import H from 'constants/httpMethod.const';
import endpoint from 'utils/backend/endpoint.util';
import actionBe from 'utils/mw/actionBe.util';

const bePutSettingsNcob = actionBe('bePutSettingsNcob', ({ AT, ATAG, data }) => endpoint(H.put, 'settings/ncob/salon/:salonId/', { AT, name: ATAG, data }));

export default bePutSettingsNcob;
